import type { PatchAssetStateRequest } from './assetPatchState';
import apiRequest from './apiRequest';

export default async function patchBatchByID(
  apiKey: string,
  batchID: string,
  body: PatchAssetStateRequest,
) {
  return apiRequest<Record<string, never>>(
    'external-mogen',
    `/batch/${encodeURIComponent(batchID)}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiKey,
      },
      body: JSON.stringify(body),
    },
  );
}
